import UserOverview from './overview'
import User from './user'
import UserCreate from './create'
module.exports = {
  UserOverview,
  User,
  UserCreate
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/users/index.js